import React, { Fragment, useState } from "react";
import PageContentWrapper from "../../../components/wrappers/PageContentWrapper";
import { Button, Paper, Stack, Typography } from "@mui/material";
import CenterScreen from "../../../components/wrappers/CenterScreen";
import FormTextField from "../../../components/form/FormTextField";
import { useForm } from "react-hook-form";
import useConfirm from "../../../hooks/useConfirm";
import { useTranslation } from "react-i18next";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  setErrorForNewEmail,
  useCheckEmail,
} from "../../profile/form/Validation/ChangeEmailValidation";
import { ERROR, SUCCESS } from "../../../enums/AlertTypes";
import NewEmailDialog from "../../profile/form/NewEmailDialog";
import authApi from "../../../utils/api/authApi";
import { VERIFY_NEW_EMAIL } from "../../../enums/ApiPaths";
import {
  getBearerToken,
  getTokenFromUrl,
  useIsMobile,
} from "../../../utils/Functions";
import { useNavigate } from "react-router-dom";
import { HOME } from "../../../enums/UrlPaths";
import { SnackbarContext } from "../../../contexts/Snackbar";
import AuthFooter from "../login/component/AuthFooter";
import HeaderNoAuth from "../../../components/display/HeaderNoAuth";
export default function ChangeEmailViewPage() {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const {
    formState: { errors },
    register,
    handleSubmit,
    setError,
    watch,
  } = useForm({
    resolver: zodResolver(useCheckEmail()),
  });

  const [isSent, setIsSent] = useState(false);
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const { ConfirmationDialog, confirm, getMessage } = useConfirm(
    t("Attention"),
    t("Accept"),
    t("Cancel")
  );
  const [urlToken, setUrlToken] = useState();

  const navigate = useNavigate();
  React.useEffect(() => {
    setUrlToken(getTokenFromUrl());
  }, []);

  async function submitData() {
    const new_email = watch().email;
    const token = urlToken;
    const data = {
      email: new_email,
    };

    getMessage(<NewEmailDialog string={new_email} />);
    const ans = await confirm();
    const header = await getBearerToken();
    if (ans) {
      try {
        await authApi.post(VERIFY_NEW_EMAIL + "?token=" + token, data, {
          headers: header,
        });
        handleSnackbar("ActionCompletedSuccessfully", SUCCESS);
        setIsSent(true);
      } catch (error) {
        setErrorForNewEmail(error?.response?.data, setError, t);
        handleSnackbar("SomethingWentWrong", ERROR);
      }
    }
  }
  function goHome() {
    navigate(HOME);
  }
  return (
    <Fragment>
      <HeaderNoAuth />
      <PageContentWrapper turnOffLogo={true}>
        <form onSubmit={handleSubmit(submitData)}>
          <CenterScreen>
            <Paper sx={{ p: 2, width: isMobile ? "90%" : "35%" }}>
              <Stack spacing={2}>
                {isSent ? (
                  <Button
                    onClick={() => {
                      goHome();
                    }}
                    sx={{ color: "white" }}
                    variant="contained"
                  >
                    {t("BackToHomePage")}
                  </Button>
                ) : (
                  <Fragment>
                    <Typography variant="button">
                      {t("EnterNewEmail")}
                    </Typography>
                    <FormTextField
                      name="email"
                      register={register}
                      errors={errors}
                      label={t("NewEmail")}
                    />
                    <Button
                      type="submit"
                      sx={{ color: "white" }}
                      variant="contained"
                    >
                      {t("ConfirmNewEmailButton")}
                    </Button>
                  </Fragment>
                )}
                <ConfirmationDialog />
              </Stack>
            </Paper>
          </CenterScreen>
        </form>
      </PageContentWrapper>
      <AuthFooter />
    </Fragment>
  );
}
